<template>
    <v-snackbar v-model="snackVisible"
                :color="snackColor"
                :top="top"
                :right="right"
                :timeout="timeout">
        {{ snackText }}
        <v-btn dark
               text
               @click="snackVisible = false">
            Cerrar
        </v-btn>
    </v-snackbar>
</template>

<script>
    export default {
        data() {
            return {
                top: true,
                right: true,
                timeout:5000,
                snackVisible: false,
                snackColor: 'success',
                snackText: ''
            }
        },
        created: function () {
            this.$store.watch(state => state.snackMessage, () => {
                const msg = this.$store.state.snackMessage;
                if (msg) {
                    this.snackVisible = true;
                    this.snackText = msg.snackText;
                    this.snackColor = msg.snackColor;
                    this.$store.commit('setText', null)
                }
            });
        }
    }
</script>